var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-container',{staticClass:"px-0",attrs:{"fluid":""}},[_c('base-row',{attrs:{"dense":""}},_vm._l((_vm.getOrder),function(order){return _c('base-col',{key:order.id,attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-lazy',{staticClass:"fill-height",attrs:{"options":{
          threshold: 0.5,
        },"transition":"fade-transition"}},[_c('list-item',{attrs:{"order":order}})],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }